import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./LoginPage";
import RouteErrorPage from './RouteErrorPage';
import useMe from './hooks/useMe';
import useDataVerify from './dataHooks/useDataVerify';
import useDataMe from './dataHooks/useDataMe';

const PrivateRoute = ({ element: Component, ...routeProps }) => {
  const { isVerified } = useMe()

  // If we are authorized...ensure we remove ssoError param
  // Re investigate what the below code is doing with sso and how it fits into our new setup
  if (isVerified) {
      const url = new URL(window.location);
      const { searchParams } = url;
      const ssoError = searchParams.get("ssoError");
      if (ssoError) {
        url.searchParams.delete("ssoError");
        // Update the URL without reloading the page
        window.history.replaceState({}, document.title, url.toString());
      }
  }

  // Ensure we have all require cookies set or foce redirect to the login page
  return (isVerified) ? <Component {...routeProps} /> : <LoginPage />;
};

const PublicRoute = ({ element: Component, ...routeProps }) => {
  return <Component {...routeProps} />;
};

export default ({
  routes = []
}) => {

  const { getIsVerified } = useDataVerify()
  const { fetchMe } = useDataMe()

  const verifyLoader = async () => {
    const isVerified = await getIsVerified()
    const me = await fetchMe()
    return { ...me, isVerified }
  };

  const publicLoader  = async () => {
    const me = await fetchMe()
    return me;
  }

  const parseRoute = (route) => {
    return route.map((routeObj) => {
      const {
        path,
        isPrivate,
      } = routeObj;
      const parsedRouteObj = { ...routeObj }
      if (path === '/') {
        parsedRouteObj.errorElement = <RouteErrorPage />;
      }

      if (isPrivate) {
        parsedRouteObj.element = <PrivateRoute {...routeObj} />;
        parsedRouteObj.loader = verifyLoader;
      } else {
        parsedRouteObj.element = <PublicRoute {...routeObj} />;
        parsedRouteObj.loader = publicLoader;
      }
      parsedRouteObj.shouldRevalidate = () => true;
      
      return parsedRouteObj
    })
  }

  const router = createBrowserRouter(parseRoute(routes));

  return <RouterProvider router={router} />
}